module.exports = __webpack_public_path__ + "static/media/octorion-ability.b48a129a.svg";